// ----------------------------------------------------------------
import { createFileRoute } from '@tanstack/react-router';
import { InboxSessionProvider } from '@/components/notifications/InboxSessionContext';
import NotificationsPage from '@/pages/notifications';
// ----------------------------------------------------------------

/**
 * The Route component is a file route that is used to render the NotificationsPage component.
 * This is a route setup for '/notifications/' route.
 */
function NotificationsRoute() {
  return (
    <InboxSessionProvider>
      <NotificationsPage pageNo={1} pageSize={50} onPageChange={() => undefined} />
    </InboxSessionProvider>
  );
}

export const Route = createFileRoute('/_authenticated-layout/notifications/')({
  component: NotificationsRoute,
}); 
